import React, { memo, useState } from "react";

import CollapsibleCategory from "./CollapsibleCategory";

import Data from "shared/components/Footer/data";

function Categories() {
    const [expandedIndex, setExpandedIndex] = useState(-1);

    return (
        <div>
            {Data.map((cat, idx) => {
                const isExpanded = expandedIndex === idx;
                return (
                    <CollapsibleCategory
                        {...cat}
                        key={idx}
                        isExpanded={isExpanded}
                        onExpanded={() => setExpandedIndex(idx)}
                    />
                );
            })}
        </div>
    );
}

export default memo(Categories);
